import { Injectable } from '@angular/core';
import { EnvironmentInterface } from '../../../environments/environment.interface';
import { environment } from '../../../environments/environment';

@Injectable({providedIn: 'root'})
export class EnvironmentService {
  public getEnvironment(): EnvironmentInterface {
    return environment;
  }
}
